import { Directive, HostListener, ElementRef, NgModule } from '@angular/core';

@Directive({
    selector: '[focusInvalidInput]',
    standalone: false
})
export class focusInputDirective {

    constructor(private el: ElementRef) { }

    @HostListener('submit') submitForm() {
        const invalidControl = this.el.nativeElement.querySelector('.ng-invalid');

        if (invalidControl) {
            invalidControl.focus();
        }
    }
}


@NgModule({
    declarations: [focusInputDirective],
    exports: [focusInputDirective]
})
export class focusInputDirectiveModule {}